module.exports = __webpack_public_path__ + "media/base/navigation-00a68140.svg";